import React from "react"
import { Route, createRoutesFromElements } from "react-router-dom"
import * as Sentry from "@sentry/react"
import * as amplitude from "@amplitude/analytics-browser"

if (import.meta.env.PROD) {
  amplitude.init("0e1b5f251b9dd40685d0188a6ee4f22f", { autocapture: true })
  Sentry.init({
    dsn: "https://17ba10dc9bfc90d9869cba78d6d99918@o978413.ingest.us.sentry.io/4509208521211904",
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event, hint) {
      // Check if the error is related to dynamic imports
      const errorMessage = (hint.originalException as { message?: string } | undefined)?.message
      if (errorMessage && errorMessage.includes("Failed to fetch dynamically imported module")) {
        // Return null to prevent the error from being sent to Sentry
        return null
      }

      // Check for the MIME type error
      if (errorMessage && errorMessage.includes("'text/html' is not a valid JavaScript MIME type")) {
        // Return null to prevent the error from being sent to Sentry
        return null
      }

      // Check for Amplitude errors
      const sentryMessage = (event as { message?: string }).message ?? ""
      if (
        sentryMessage.includes("TypeError: Load failed (api-sr.eu.amplitude.com)") ||
        sentryMessage.includes("Failed to store session replay events in IndexedDB")
      ) {
        return null
      }

      // Otherwise, send the error to Sentry
      return event
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  })
}

export const router = () => {
  return createRoutesFromElements(
    <React.Fragment>
      <Route
        path="/"
        lazy={async () => {
          const { LandingPage } = await import("./landing")
          return { Component: LandingPage }
        }}
      />
      <Route
        path="/welcome"
        lazy={async () => {
          const { WelcomePage } = await import("./welcome")
          return { Component: WelcomePage }
        }}
      />
      <Route
        path="/space/:brandId"
        lazy={async () => {
          const { HomePage } = await import("./HomePage")
          return { Component: HomePage }
        }}
      />
      <Route
        path="/space/:brandId/book/:id"
        lazy={async () => {
          const { BookPage } = await import("./BookPage")
          return { Component: BookPage }
        }}
      />
      <Route
        path="/space/:brandId/paymentSuccess"
        lazy={async () => {
          const { PaymentSuccess } = await import("./PaymentSuccess")
          return { Component: PaymentSuccess }
        }}
      />
      <Route
        path="/legal"
        lazy={async () => {
          const { Legal } = await import("./Legal")
          return { Component: Legal }
        }}
      />
      <Route
        path="/privacy"
        lazy={async () => {
          const { Privacy } = await import("./Privacy")
          return { Component: Privacy }
        }}
      />
      <Route
        path="/space/:brandId/legal"
        lazy={async () => {
          const { Legal } = await import("./Legal")
          return { Component: Legal }
        }}
      />
      <Route
        path="/space/:brandId/privacy"
        lazy={async () => {
          const { Privacy } = await import("./Privacy")
          return { Component: Privacy }
        }}
      />
      <Route
        path="/me/stripe-refresh"
        Component={() => {
          window.location.href = "boncowork:///"
          return null
        }}
      />
      <Route
        path="/me/stripe-return"
        Component={() => {
          window.location.href = "boncowork:///"
          return null
        }}
      />
      <Route
        path="/download"
        lazy={async () => {
          const { DownloadPage } = await import("./DownloadPage")
          return { Component: DownloadPage }
        }}
      />
      <Route
        path="/invoices/:invoiceUUID"
        lazy={async () => {
          const { InvoicePage } = await import("./InvoicePage")
          return { Component: InvoicePage }
        }}
      />

    </React.Fragment>,
  )
}
